"use strict";

const getActiveListType = () => document.querySelector('.anchor-type-item.active').dataset.listType;
const loadMoreTimesMap = JSON.parse(document.currentScript.dataset.loadMoreTimes);
function showLoadMoreButtonOrNot() {
  /*
      There is no need for the code to run on the desktop screen width
      because there is no button that the code refers to.
  */
  const maxLoadMoreTimes = 2;
  if (window.matchMedia('screen and (max-width: 1023px)').matches) {
    if (loadMoreTimesMap[getActiveListType()] >= maxLoadMoreTimes) {
      const mostAnchorLoaderWrap = document.querySelector('#mostAnchorLoadMoreButton');
      mostAnchorLoaderWrap.style.display = 'none';
    }
  }
}

// eslint-disable-next-line no-unused-vars
function prepareElement() {
  showLoadMoreButtonOrNot();
}

// eslint-disable-next-line no-unused-vars
function countClicks() {
  loadMoreTimesMap[getActiveListType()] += 1;
  showLoadMoreButtonOrNot();
}
function showMostLoader() {
  const mostAnchorLoaderWrap = document.querySelector('#mostAnchorLoaderWrap');
  mostAnchorLoaderWrap.removeAttribute('hidden');
}

// eslint-disable-next-line no-unused-vars
function hideMostLoader() {
  const mostAnchorLoaderWrap = document.querySelector('#mostAnchorLoaderWrap');
  mostAnchorLoaderWrap.setAttribute('hidden', true);
}
const getNumOfItems = () => {
  let numOfItems = 4;
  if (window.matchMedia('screen and (min-width: 1024px)').matches) {
    numOfItems = 7;
  }
  return numOfItems;
};

// eslint-disable-next-line no-unused-vars
function toggleMostActiveList(element, listContentType) {
  const mostAnchorWidget = document.querySelector('#mostAnchorWidget');
  const mostAnchorTypeList = document.querySelector('#mostAnchorTypeList');
  const activeListItem = mostAnchorTypeList.querySelector('.active');
  if (activeListItem !== element) {
    const existingAnchorItems = mostAnchorWidget.querySelectorAll('.anchor-item');
    activeListItem.classList.remove('active');
    element.classList.add('active');
    existingAnchorItems.forEach(item => item.remove());
    showMostLoader();
    window.Unicorn.call('most-anchor', 'toggle_active_list', listContentType, getNumOfItems());
  }
}

// eslint-disable-next-line no-unused-vars
function loadMostNextPage() {
  showMostLoader();
  window.Unicorn.call('most-anchor', 'load_next_page');
}
if (!window.initUnicornComponent) {
  document.addEventListener('FeedInitialized', () => {
    window.initUnicornComponent('most-anchor');
  });
} else window.initUnicornComponent('most-anchor');